import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import {labelCropYieldGoal} from './LabelCropYieldGoal';

const useStyles = makeStyles((theme) => ({
    root: {
        '& > *': {
            margin: theme.spacing(1),
            width: '25ch',
        },
    },
}));


export default function CropYieldGoal(props) {
    const classes = useStyles();

    const handleSubmit = (event) => {
        event.preventDefault();
        // console.log('---------- pressed enter ----');
        props.handleNext(event);
    }
    const handleChange = (event) => {
        props.switchWizardYieldGoal(event.target.value);
    };

    const langPref = props.beagleLanguagePreference;

    const labelYieldGoal = labelCropYieldGoal.labelYieldGoal[langPref];

    let labelYieldGoalUnit = props.cropDefinition.mathUnit['i'];
    if (props.beagleMathPreference === 'm') {
        labelYieldGoalUnit = props.cropDefinition.mathUnit['m'];
    }

    const myLabel = labelYieldGoal + ', ' + labelYieldGoalUnit;

    return (
        <form className={classes.root} noValidate autoComplete="off" onSubmit={handleSubmit}>
            <TextField type="number" id="standard-basic" label={myLabel} onChange={handleChange}
                       value={props.wizardYieldGoal}/>
        </form>
    );
}
